import React, { useEffect, useRef, useState } from "react";
import { useAppContext } from "../../context/appContext";
import { ImageContainer } from "../../pages/home/modules/imageContainer";
import { SmoothScroll } from "../smoothScroll";
import { useLenis } from "lenis/react";
import ScrollSnap from 'lenis/snap';
import codeIcon from '../../assets/icons/code.svg';
import { Menu } from "../../modules/menu";

export const Pages = ({ children }) => {
  const { loading, menuOpen, loadingTime } = useAppContext();
  const lenis = useLenis();
  const [hideNotFound, setHideNotFound] = useState(true);

  useEffect(()=>{
    if (loading){
      setHideNotFound(true);
      return;
    }

    setTimeout(()=>{
      setHideNotFound(false);
    }, loadingTime / 2);

    const focused = document.querySelectorAll(':focus');
    focused.forEach((el)=> el.blur());

  },[loading]);

  return (
    
      <div 
        className={`
          flex bg-gradient flex-col min-h-screen max-w-[100vw]
          [&_button]:ring-blue-600 [&_button]:rounded-xl [&_button:focus]:ring-2 [&_button]:outline-none
          [&_a]:ring-blue-600 [&_a]:rounded-xl [&_a:focus]:ring-2 [&_a]:outline-none
          [&_input]:ring-blue-600 [&_input:focus]:ring-2 [&_input]:outline-none
          [&_textarea]:ring-blue-600 [&_textarea:focus]:ring-2 [&_textarea]:outline-none
          overflow-x-hidden overflow-y-auto [&_.not-found]:bg-transparent
          [&_.contact]:[&_.bottom-info]:bg-transparent
        `}
      >
        <SmoothScroll>
          {children}

          <Menu className="z-[45]" />

          <div
            className={`
              loader fixed inset-0 z-50 flex items-center justify-center
              bg-black/70 backdrop-blur-md transition-[opacity]
            `}
            style={{
              opacity: loading ? 100 : 0,
              pointerEvents: loading ? 'all': 'none',
              transitionDuration: loadingTime / 2,
            }}
          >
            <img 
              className="w-[8vw] min-w-[80px] sm:min-w-[100px] logo-pulse white-svg" 
              src={codeIcon} 
            />
          </div>
        </SmoothScroll>
      </div>
  );
};
